// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606150536/js/" + chunkId + "." + {"44":"4aa2f7a0","225":"c6c9a951","481":"0b043f1d","486":"0e6bd437","770":"0d6fdd57"}[chunkId] + ".0.19742685857626086.chunk.js";
};